import React from 'react';
import * as R from 'ramda';
import classNames from 'classnames';

import Button from 'js/components/button';

import './index.scss';

function pinterestBoards(boards, onBoardSelected) {
    return R.pipe(
        R.defaultTo([]),
        R.map(board => {
            const classes = classNames('button__option', 'pinterest-button__board', {
                'pinterest-button__board--locked': board.locked
            });
            return (
                <div
                    key={board.id}
                    className={classes}
                    onClick={() => onBoardSelected && onBoardSelected(board)}
                >
                    <div className="pinterest-button__board-name">{board.name}</div>
                </div>
            );
        }),
        R.prepend(
            <div key="header" className="pinterest-button__options-header">
                Choose a board to pin to
            </div>
        )
    )(boards);
}

export default function PinterestButton({boards, disabled, onClick, onBoardSelected, children}) {
    return (
        <Button
            disabled={disabled}
            pinterest
            mini
            showOptionsOn="click"
            onClick={onClick}
            options={R.isNil(boards) ? null : pinterestBoards(boards, onBoardSelected)}
        >
            {children}
        </Button>
    );
}



// WEBPACK FOOTER //
// ./components/pinterest_button/index.js